import { useLocation, useNavigate } from 'react-router-dom'

export const useHashTabs = (defaultTab: string) => {
  const { hash, pathname, search } = useLocation()
  const navigate = useNavigate()
  const setTab = (tab: string) => {
    navigate(`${pathname}${search}${tab}`, { replace: true })
  }
  return { currentTab: hash || defaultTab, setTab }
}
